angular.module('blc').factory('xlat_service', xlat_srv);
xlat_srv.$inject = ['browser'];
function xlat_srv(browser) {
  var current_lang = 'en';
  // var tables = $.extend(true, {}, initial_xlat_tables);
  var tables = {}
  browser.getData.then(function(data) {
    tables = data.data.i18;
  });
  
  return {
    set_lang: function(lang) { 
      current_lang = lang;
    },
    get_lang: function() { return current_lang; },
    xlat: xlat
  }
  function xlat(label, params) {
    if (typeof tables=='undefined' || current_lang=='en' || typeof tables[current_lang]=='undefined') return label;
    return tables[current_lang][label] || label;
  }
}

angular.module('blc').filter('xlat', ['xlat_service', function(xlat_service) {
  function filterFn(label,params) {
    return xlat_service.xlat(label, params);
  }
  filterFn.$stateful = true;
  return filterFn;
}]);

angular.module('blc').directive('blcI18', i18_directive);
i18_directive.$inject = ['xlat_service']
function i18_directive(xlat_service) {
  return {
    restrict: 'A',
    controller: ['$scope','$element', function($scope, $element) {
      $scope.$watch(function() { return xlat_service.get_lang(); }, function(curr, prev) {
        if (curr==prev) return ;
        var tr = xlat_service.xlat($element.text());
        $element.html(tr);
      });
    }]
  }
}



/*****************
 ** WEBPACK FOOTER
 ** ./gulp/assets/javascripts/xlat-service.js
 ** module id = 18
 ** module chunks = 0
 **/